import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid/lib/index";
import {
  Card,
  CardActionArea,
  CardHeader,
  CardContent,
  Collapse,
  FormControl,
  Button,
  InputLabel,
  MenuItem,
  Select,
  IconButton
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Search from "@material-ui/icons/Search";
import ShareIcon from "@material-ui/icons/Share";
import Refresh from "@material-ui/icons/Refresh";
import DatePickerWrapped from "components/DatePickerWrapped";

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250
  },
  chip: {
    margin: theme.spacing(0.25)
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    }),
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      marginRight: -8
    }
  },
  expandOpen: {
    transform: "rotate(180deg)"
  }
});

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 200,
      width: 250
    }
  }
};

function FilesFilterCard(props) {
  const {
    soloConfirmStartDateFilter,
    soloConfirmEndDateFilter,
    soloConfirmInstrumentNumFilter,
    onSoloConfirmStartDateFilterChange,
    onSoloConfirmEndDateFilterChange,
    onSoloConfirmInstrumentNumFilterChange,
    onFindFilesClick,
    soloUIDLookup,
    classes
  } = props;

  const [isExpanded, setIsExpanded] = useState(true);
  const [copyText, setCopyText] = useState("Copy Query");

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  const handleCopyButtonClick = () => {
    navigator.clipboard.writeText(window.location.href);
  };

  return (
    <div>
      <Card style={{ overflow: "visible" }}>
        <CardActionArea disableRipple component="a" onClick={handleExpandClick}>
          <CardHeader
            title="Search Options"
            action={
              <IconButton
                className={isExpanded ? classes.expandOpen : classes.expand}
                onClick={handleExpandClick}
                aria-expanded={isExpanded}
                aria-label="show more"
                style={{ marginTop: -9 }}
              >
                <ExpandMoreIcon />
              </IconButton>
            }
          />
        </CardActionArea>
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Row bottom="xs">
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <DatePickerWrapped
                  floatingLabelText="Survey Date from"
                  maxDate={soloConfirmEndDateFilter}
                  value={soloConfirmStartDateFilter}
                  onChange={onSoloConfirmStartDateFilterChange}
                />
              </Col>
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <DatePickerWrapped
                  floatingLabelText="Survey Date to"
                  minDate={soloConfirmStartDateFilter}
                  value={soloConfirmEndDateFilter}
                  onChange={onSoloConfirmEndDateFilterChange}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <FormControl
                  fullWidth
                  style={{ marginBottom: 15, marginTop: 15 }}
                >
                  <InputLabel>Instrument number</InputLabel>
                  <Select
                    value={soloConfirmInstrumentNumFilter}
                    onChange={onSoloConfirmInstrumentNumFilterChange}
                    MenuProps={MenuProps}
                  >
                    <MenuItem value="any">Any</MenuItem>
                    {Object.entries(props.soloUIDLookup)
                      .sort(
                        (a, b) =>
                          parseInt(a[1].substring(1), 10) -
                          parseInt(b[1].substring(1), 10)
                      )
                      .map(([key, value]) => (
                        <MenuItem key={key} value={key}>
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Col>
              <Col xs={12} md={6} lg={4} lgOffset={1}>
                <FormControl
                  fullWidth
                  style={{ marginBottom: 15, marginTop: 15 }}
                >
                  <InputLabel>Serial number</InputLabel>
                  <Select
                    value={soloConfirmInstrumentNumFilter}
                    onChange={onSoloConfirmInstrumentNumFilterChange}
                    MenuProps={MenuProps}
                  >
                    <MenuItem value="any">Any</MenuItem>
                    {Object.keys(soloUIDLookup).map(number => {
                      return (
                        <MenuItem key={number} value={number}>
                          {number}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Col>
            </Row>
            <Col xs={12} md={6} lg={5} lgOffset={1}>
              <Row>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={onFindFilesClick}
                  style={{
                    marginTop: "15px",
                    marginBottom: "15px",
                    color: "#fff"
                  }}
                >
                  Search
                  <Search />
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    handleCopyButtonClick();
                    setCopyText("Copied URL");
                  }}
                  style={{
                    marginTop: "15px",
                    marginBottom: "15px",
                    marginLeft: "15px",
                    color: "#fff"
                  }}
                >
                  {copyText}
                  <ShareIcon />
                </Button>
                <Button
                  style={{ marginLeft: "10px" }}
                  default
                  // icon={<NavigationRefresh />}
                  onClick={props.onClearForm}
                >
                  Reset
                  <Refresh />
                </Button>
              </Row>
            </Col>
          </CardContent>
        </Collapse>
      </Card>
    </div>
  );
}

FilesFilterCard.propTypes = {
  classes: PropTypes.shape({
    expand: PropTypes.string,
    expandOpen: PropTypes.string
  }).isRequired,
  onClearForm: PropTypes.func.isRequired,
  soloConfirmStartDateFilter: PropTypes.string,
  soloConfirmEndDateFilter: PropTypes.string,
  soloConfirmInstrumentNumFilter: PropTypes.string,
  onSoloConfirmStartDateFilterChange: PropTypes.func.isRequired,
  onSoloConfirmEndDateFilterChange: PropTypes.func.isRequired,
  onSoloConfirmInstrumentNumFilterChange: PropTypes.func.isRequired,
  onFindFilesClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  soloUIDLookup: PropTypes.object.isRequired
};

FilesFilterCard.defaultProps = {
  soloConfirmStartDateFilter: undefined,
  soloConfirmEndDateFilter: undefined,
  soloConfirmInstrumentNumFilter: "any"
};

export default withStyles(styles)(FilesFilterCard);
